import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { MapPin } from "lucide-react";
import { inputCls } from "./ui";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AddressInput = ({ value, onChange, placeholder, testid, mode = "address", inputClassName }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef(null);
  const justSelected = useRef(false);
  const touched = useRef(false);

  useEffect(() => {
    clearTimeout(timer.current);
    if (justSelected.current) {
      justSelected.current = false;
      setSuggestions([]);
      setOpen(false);
      return;
    }
    if (!touched.current) return;
    if (!value || value.trim().length < 3) {
      setSuggestions([]);
      return;
    }
    timer.current = setTimeout(async () => {
      try {
        const { data } = await axios.get(`${API}/places`, { params: { input: value, mode } });
        setSuggestions(data.suggestions || []);
        setOpen(true);
      } catch {
        setSuggestions([]);
      }
    }, 350);
    return () => clearTimeout(timer.current);
  }, [value, mode]);

  return (
    <div className="relative">
      <input
        className={inputClassName || inputCls}
        value={value}
        placeholder={placeholder}
        autoComplete="off"
        onChange={(e) => { touched.current = true; onChange(e.target.value); }}
        onFocus={() => suggestions.length > 0 && setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        data-testid={testid}
      />
      {open && suggestions.length > 0 && (
        <div className="absolute left-0 right-0 top-full z-30 border border-line bg-coal shadow-2xl" data-testid={`${testid}-suggestions`}>
          {suggestions.map((s) => (
            <button
              key={s.place_id}
              type="button"
              onMouseDown={() => {
                justSelected.current = true;
                onChange(s.description);
                setSuggestions([]);
                setOpen(false);
              }}
              className="flex w-full items-center gap-3 border-b border-line/50 px-4 py-3 text-left text-sm text-slate-700 transition-colors last:border-b-0 hover:bg-slate-100 hover:text-slate-900"
              data-testid={`${testid}-option`}
            >
              <MapPin className="h-3.5 w-3.5 shrink-0 text-blaze" />
              {s.description}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
